export const iconFontAwesomeShoppingCcPaypal = (
	<i className="fa-solid fa-cc-paypal"></i>
);
